import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'items.allowBarcodeRegistration' (TW 36320099).
 * Styrer om operatøren kan registrere nye/alternative strekkoder på en vare fra
 * varemottaket (og vareadmin). Kan settes på system- og profilnivå — profilnivået
 * lar en tenant begrense registrering til f.eks. lagersjefer.
 *
 * Default: true (registrering tillatt med mindre den eksplisitt skrus av).
 */
export function useBarcodeRegistrationEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('items.allowBarcodeRegistration');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setEnabled(val === 'true' || val === '1' || val === 'ja');
          } else {
            setEnabled(true);
          }
        }
      } catch (err) {
        console.warn('Could not load items.allowBarcodeRegistration setting, defaulting to true:', err);
        if (!cancelled) {
          setEnabled(true);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return enabled;
}
